import { Component } from '@angular/core';

@Component({
    selector: 'eca-error-insufficient-permissions-landing',
    templateUrl: './error-insufficient-permissions-landing.component.html',
    styleUrls: ['./error-insufficient-permissions-landing.component.css']
})
export class ErrorInsufficientPermissionsLandingComponent {

  constructor() { }
}
